import React from 'react';
import { Database, Smartphone, Headset, Zap, BarChart3, Search, ShieldCheck, RefreshCw, Cpu } from 'lucide-react';

const features = [
  { icon: Zap, title: "Cutting-Edge Tech Stacks", desc: "We leverage the latest frameworks to ensure your application remains fast, modern, and competitive." },
  { icon: Smartphone, title: "Mobile-First Design", desc: "Seamless experiences across all devices with responsive, high-performance interfaces." },
  { icon: Headset, title: "Dedicated 24/7 Support", desc: "Ongoing maintenance and priority support to ensure your business never faces downtime." },
  { icon: Database, title: "Scalable Architecture", desc: "Designed for growth, our solutions handle increasing traffic and data with ease." },
  { icon: ShieldCheck, title: "Enterprise-Grade Security", desc: "Advanced security protocols to protect your business data and user privacy." },
  { icon: RefreshCw, title: "Agile Development", desc: "Iterative, transparent processes that ensure rapid delivery and flexibility." },
  { icon: Cpu, title: "Performance Engineering", desc: "Deep technical analysis to optimize loading speeds and operational efficiency." },
  { icon: BarChart3, title: "Data-Driven Insights", desc: "Leverage advanced analytics to drive better business outcomes and user engagement." },
  { icon: Search, title: "SEO & Visibility", desc: "Optimized architecture that helps your brand rank higher and reach your target audience." }
];

const WhyChooseUs = () => {
  return (
    <section className="relative py-16 px-6 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] transition-colors duration-300">
      
  <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* 2. GRID OVERLAY */}
      <div className="absolute inset-0 opacity-[0.04] dark:opacity-[0.03]" 
           style={{ 
             backgroundImage: 'linear-gradient(#000 1px, transparent 1px), linear-gradient(90deg, #000 1px, transparent 1px)', 
             backgroundSize: '60px 60px' 
           }}>
      </div>

      {/* 3. CONTENT WRAPPER */}
      <div className="relative z-10 max-w-7xl mx-auto">
              <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
               Why We Choose for  {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Development
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
 We don't just build websites; we craft high-performance digital ecosystems designed to accelerate your business growth.</p>
      </div>
     

        {/* 3x3 Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((item, i) => (
            <div key={i} className="p-8 bg-white dark:bg-[#1a1a1a] rounded-3xl border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-xl hover:border-orange-500/30 transition-all duration-300 group">
              <div className="w-12 h-12 bg-orange-50 dark:bg-orange-900/20 rounded-xl flex items-center justify-center mb-6 transition-colors group-hover:bg-primary">
                <item.icon className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900 dark:text-white">
                {item.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;